var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal)?_c('div',{staticClass:"svg-external-icon svg-icon",class:_vm.className,style:(_vm.styleExternalIcon)}):_c('svg',{staticClass:"svg-icon",class:_vm.className,attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }